import { render } from "./Stars.vue?vue&type=template&id=9487d30c"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trevorwagner/Sites/Starkey/wp-content/themes/starkey-realty/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__